export enum LensSimulationType {
  soft = 'Soft',
  fluor = 'Fluor',
  none = 'None'
}
